/** Swap two adjacent rows and re-index the whole list, patching only the rows
 * whose `order` actually changed (robust to pre-existing gaps/dupes). */
export function reorderRows<T extends { order: number }>(
  items: T[],
  index: number,
  dir: -1 | 1,
  patch: (item: T, order: number) => void,
) {
  const target = index + dir;
  if (target < 0 || target >= items.length) return;
  const next = [...items];
  [next[index], next[target]] = [next[target], next[index]];
  next.forEach((item, i) => {
    if (item.order !== i) patch(item, i);
  });
}
